<template>

  <svg
    t="1640016193753"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="3997"
    width="64"
    height="64"
  ><path d="M819.98000001 764H204.01999999V260h616.02000001v504zM260 708.02000001h504V315.97999999H260v392.04000002zM764 92v55.98000001h112.02000001V260H932V92h-168zM92 92v168h55.98000001V147.97999999H260V92H92zM876.02000001 764v112.02000001H764V932H932v-168h-55.98000001zM147.97999999 876.02000001V764H92V932h168v-55.98000001H147.97999999z" p-id="3998" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconFullscreen',
} as DefineComponent
</script>